import { getLocale, t } from "@/i18n";

function russianDocumentForm(count: number): "one" | "few" | "many" {
  const absolute = Math.abs(count);
  const lastTwoDigits = absolute % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return "many";

  const lastDigit = absolute % 10;
  if (lastDigit === 1) return "one";
  if (lastDigit >= 2 && lastDigit <= 4) return "few";
  return "many";
}

export function formatFoundDocuments(count: number): string {
  const form =
    getLocale() === "ru"
      ? russianDocumentForm(count)
      : count === 1
      ? "one"
      : "many";

  return t(`documentList.foundDocuments.${form}`).replace(
    "{count}",
    String(count)
  );
}
